import * as React from 'react'
import Carousel from 'src/share/components/Carousel/Carousel';
import useCarousel from 'src/share/components/Carousel/hooks/useCarousel';
import ChildBanner from './ChildBanner';

const GDCarousel = ({ recentCases, onTransition }): React.ReactElement => {
  const [{ currentIndex, isPlaying }, actions] = useCarousel(recentCases.length);
  React.useEffect(() => {
    if(recentCases.length) {
      onTransition(recentCases[currentIndex].center);
    }
  }, [currentIndex]);
  return (
    <div className="child-banner white-background">
      <Carousel
        currentIndex={currentIndex}
        isPlaying={isPlaying}
        withControls={false}
        onPause={actions.handlePause}
        onPlay={actions.handlePlay}
        onNext={actions.handleNext}
        onPrev={actions.handlePrev}
        onGoTo={actions.handleGoTo}
      >
        {recentCases.map((child: any, index) => (
          <ChildBanner 
            key={index}
            id={`image-${index}`}
            child={child}
            isCurrent={index === currentIndex}
          />
        ))}
      </Carousel>
    </div>
  )
}

export default React.memo(GDCarousel);



// WEBPACK FOOTER //
// ./src/modules/Dashboard/Global/components/GDCarousel.tsx